import { PosterImage } from "../../../../../ui/poster/image.js";
import { PosterRoot } from "../../../../../ui/poster/root.js";
import { jsx, jsxs } from "react/jsx-runtime";
import { cn, resolveClassName } from "@videojs/utils/style";
//#region src/internal/skins/shared/components/layout/poster.tsx
/** @jsxImportSource react */
function Poster({ children, className, renderImage, ...props } = {}) {
	return /* @__PURE__ */ jsxs(PosterRoot, {
		className: (state) => cn("media-poster", resolveClassName(className, state)),
		children: [/* @__PURE__ */ jsx(PosterImage, {
			render: renderImage,
			className: "media-poster-image",
			...props
		}), children]
	});
}
//#endregion
export { Poster };

//# sourceMappingURL=poster.js.map